import {DeliveryPointType} from "@app/core/delivery-point/application/dtos/delivery-point-type";
import {PaymentMethodType} from "@app/core/delivery-point/application/dtos/payment-method-type";
import {PaymentMethodTypeMapper} from "@app/core/delivery-point/infrastructure/mappers/payment-method-type.mapper";

export class OrderTypeMapper {
    static deserialize(param: any): DeliveryPointType {
        return {
            paymentMethods: param.payment_method.map((method: string) => PaymentMethodTypeMapper.deserialize(method)) ,
            dates: param.dates.map((date: string) => new Date(date)) //Create Date from yyyy-mm-dd
        }
    }

    static serialize(param: DeliveryPointType): any {
        return {
            payment_method: param.paymentMethods.map((method: PaymentMethodType) => PaymentMethodTypeMapper.serialize(method)),
            dates: param.dates.map((date: Date) => date.toISOString().split('T')[0]) //Format Date as yyyy-mm-dd
        }
    }
}
